import { Component, OnInit } from '@angular/core';
import { TextblockComponent } from '../../shared/components/textblock/textblock.component';
import { ITextblock } from '../../core/interfaces/textblock.interface';
import { StatusService } from 'src/app/core/services/status.service';

@Component({
  selector: 'aig-confirm-page',
  imports: [TextblockComponent],
  templateUrl: './confirm-page.component.html',
  styleUrls: ['./confirm-page.component.scss'],
})
export class ConfirmPageComponent implements OnInit {
  heroInfo = {
    image: './assets/images/bg-ciberseguridad.jpg',
    alt: 'Imagen top',
  };

  public status: string = 'ok';

  public statusData: ITextblock[] = [
    {
      status: 'ok',
      icon: 'icon-open-email',
      title: '¡Muchas gracias por confiar en nosotros!',
      subtitle:
        'En la bandeja de entrada encontrarás toda la documentación relativa a la póliza',
    },
    {
      status: 'ko',
      icon: 'icon-warning-advertencia',
      title: 'Ha ocurrido un error inesperado',
      subtitle:
        'Por favor, inténtelo más tarde o póngase en contacto con backoffice.caixa@icp.es',
    },
  ];

  constructor(private statusService: StatusService) {}

  ngOnInit() {
    this.statusService.status$.subscribe((status) => {
      this.status = status;
    });
  }

  public getCurrentStatus(): ITextblock {
    let current: ITextblock = {
      status: '',
      icon: '',
      title: '',
      subtitle: '',
    };

    this.statusData.some((i) => {
      if (i.status === this.status) {
        current = i;
        return true;
      }
      return false;
    });

    return current;
  }
}
